<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex md6 class="col-12 fxt-bg-img" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                            
                <div class="fxt-form">                               
                  <h2>{{$t("password.title")}}</h2>
              <!--**********************   Form   ************************************************** -->
                  <Form ref="formInline" :model="formInline" :rules="ruleInline">
                    <FormItem prop="regEmail">
                      <Input readonly v-model="formInline.regEmail" placeholder="Email"></Input>
                    </FormItem>
                    <FormItem prop="passWord">
                      <Input v-model="formInline.passWord" placeholder="New Password" type="password"></Input>
                    </FormItem>
                    <FormItem prop="confirmPassWord">
                      <Input v-model="formInline.confirmPassWord" placeholder="Confirm password" type="password"></Input>
                    </FormItem>
                    <FormItem class="text-lg-center">
                      <v-btn class="primary" dark @click="handleSubmit('formInline')">{{$t("password.resetButton")}}</v-btn>
                    </FormItem>
                </Form>
                <div class="text-lg-center font-14">
                  <span>{{$t("header.accountHint")}}?</span>
                  <span @click="gotoRegister" class="primary--text pointer mr-2">{{$t("header.signUp")}}</span>
                </div>
                </div> 
                <div class="fxt-footer">
                    <ul class="fxt-socials">
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                            <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                        </li>
                    </ul>
                </div>
              </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>

<script>
import Md5 from "js-md5";
import $ from 'jquery';
import config from "../../config.js";
export default {
  data() {
    const passWord = (rule, value, callback) => {
      // let passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
      let passreg = /^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/;
      if (value == 0) {
        callback(
          new Error(this.$t("resetPassword.errorCallback.passWord.empty"))
        );
      } else if (!passreg.test(value)) {
        callback(
          new Error(this.$t("resetPassword.errorCallback.passWord.value"))
        );
      } else {
        callback();
      }
    };
    const confirmPassWord = (rule, value, callback) => {
      if (value == 0) {
        callback(
          new Error(
            this.$t("resetPassword.errorCallback.confirmPassWord.again")
          )
        );
      } else if (value !== this.formInline.passWord) {
        callback(
          new Error(
            this.$t("resetPassword.errorCallback.confirmPassWord.match")
          )
        );
      } else {
        callback();
      }
    };
    return {
      formInline: {
        regEmail: "",
        passWord: "",
        confirmPassWord: ""
      },
       domainName: config.ip,
      ruleInline: {
        passWord: [{ required: true, validator: passWord, trigger: "blur" }],
        confirmPassWord: [
          { required: true, validator: confirmPassWord, trigger: "blur" }
        ]
      }
    };
  },
  mounted: function() {
    this.getRegEmail();
    this.background();
  },
  methods: {
    background(){
        $("[data-bg-image]").each(function() {
          var img = $(this).data("bg-image");
            $(this).css({
              backgroundImage: "url(" + img + ")"
            });
        })
    },
    getRegEmail: function() {
      let url = window.location.href;
      var email = url.substring(url.indexOf("=", 1) + 1, url.indexOf("#", 1));
      this.formInline.regEmail = email;
    },
    gotoLogin: function() {
      window.location.href = config.ip + "#/login";
    },
    gotoRegister: function() {
      this.$router.push({ name: "register" });
    },
    findPassword: function() {
      this.$router.push({ name: "password" });
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //校验成功后，发送请求
          let api = config.baseUrl + "user/open/updatePasswordByRegEmail";
          let passWord = Md5(this.formInline.passWord);
          passWord = passWord
            .split("")
            .reverse()
            .join("");
          passWord = Md5(passWord);
          // 第二版本sha256密码
          let sha256 = require("js-sha256").sha256;
          let possWord_v2 = sha256(this.formInline.passWord);
          const userFormData = {
            regEmail: this.formInline.regEmail,
            passWord: passWord,
            passWord_v2: possWord_v2
          };
          this.$http.post(api, userFormData).then(
            function(successData) {
              let data = successData.data;
              if (data.resCode == 0) {
                this.$refs[name].resetFields();
                window.location.href = config.ip;
                this.$Message.success(this.$t("resetPassword.successMessage"));
              } else if (data.resCode == -1) {
                this.$Message.error(this.$t("common.fail"));
              }
            },
            function(errorData) {
              this.$Message.error(this.$t("common.fail"));
            }
          );
        } else {
          this.$Message.error(this.$t("common.fail"));
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?7c0223f9